<template>
  <TachoFileAnalysis
    :detail-only="true"
    :driver-id="driverId"
  />
</template>

<script lang="ts">
import { defineComponent, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import TachoFileAnalysis from '@/components/content/TachoFileAnalysis.vue'

export default defineComponent({
  name: 'TachoDriverActivityView',
  components: { TachoFileAnalysis },
  props: {
    driverId: {
      type: [Number, String],
      required: true,
    },
  },
  emits: ['pageName'],
  setup(props, context) {
    const i18n = useI18n()

    context.emit('pageName', i18n.t('aside.menu.pages.tachoAnalysis'))

    watch(() => i18n.locale.value, () => {
      context.emit('pageName', i18n.t('aside.menu.pages.tachoAnalysis'))
    })
  },
})
</script>
